import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const canCreateNewAppContext = React.createContext({});
export let canCreateNewAppMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMCanCreateNewAppContent = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  canCreateNewAppMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(canCreateNewAppMachine);

  return {
    canCreateNewAppMachine,
    canCreateNewAppState: state,
    canCreateNewAppSend: send,
  };
};
